import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewContainerRef,
  ViewEncapsulation,
} from "@angular/core";
import { Overlay, OverlayRef } from "@angular/cdk/overlay";
import { Subject, takeUntil } from "rxjs";
import { HeaderTextService } from "./header-text.service";
import { Router } from '@angular/router';
import { TitleType } from "./header-text.types";

import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';

@Component({
  selector: "header-text",
  templateUrl: "./header-text.component.html",
  encapsulation: ViewEncapsulation.None,
  exportAs: "headerText",
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, MatMenuModule, MatButtonModule],
  host: {
    'class': 'flex-1 min-w-0 flex'
  }
})
export class HeaderTextComponent implements OnInit, OnDestroy {

  @Input() posicion: 'cabecera' | 'pantalla' = 'cabecera';

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    public _headerTextService: HeaderTextService,
    private _overlay: Overlay,
    private _viewContainerRef: ViewContainerRef
  ) { }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
  }

  getTitulo() {
    let titulo = this._headerTextService.getTitulo();
    if (titulo && titulo['custom_title']) {
      return titulo['titulo'];
    }
    return TitleType.find((title) => title.path === titulo)?.text;
  }
  
  getPath() {
    return this._headerTextService.getTitulo() != "/" ? this._headerTextService.getTitulo() : "";
  }

  hasBreadcrumbs(): boolean {
    const titulo = this._headerTextService.getTitulo();
    return !!(titulo && typeof titulo === 'object' && (titulo as any).breadcrumbs && (titulo as any).breadcrumbs.length > 0);
  }

  getBreadcrumbs() {
    const titulo = this._headerTextService.getTitulo();
    return (titulo && typeof titulo === 'object') ? (titulo as any).breadcrumbs || [] : [];
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

}
